import theme from '../theme';

export interface IFormScale {
  [score: number]: {
    shortName: string;
    color: string;
    desc: string;
  };
}

export const formScale: IFormScale = {
  1: {
    shortName: 'Crisis',
    color: `${theme.scale['01']}`,
    desc: 'Crisis - Please reach out to me'
  },
  2: {
    shortName: 'Struggling',
    color: `${theme.scale['02']}`,
    desc: 'I am struggling and need help'
  },
  3: {
    shortName: 'Extremely Low',
    color: `${theme.scale['03']}`,
    desc: 'Extremely Low Form'
  },
  4: {
    shortName: 'Very Low',
    color: `${theme.scale['04']}`,
    desc: 'Very Low Form'
  },
  5: {
    shortName: 'Low',
    color: `${theme.scale['05']}`,
    desc: 'Low Form'
  },
  6: {
    shortName: 'Average',
    color: `${theme.scale['06']}`,
    desc: 'Average Form'
  },
  7: {
    shortName: 'Good',
    color: `${theme.scale['07']}`,
    desc: 'Good Form'
  },
  8: {
    shortName: 'Very Good',
    color: `${theme.scale['08']}`,
    desc: 'Very Good Form'
  },
  9: {
    shortName: 'Exceptional',
    color: `${theme.scale['09']}`,
    desc: 'Exceptional Form'
  },
  10: {
    shortName: 'Peak',
    color: `${theme.scale['10']}`,
    desc: 'All-time Peak Form'
  }
};
